const setHomeworkList = (data) => ({
  type: "SET_HOMEWORK_LIST",
  data,
});

export const mutation = {
  setHomeworkList,
};
